// extracted by mini-css-extract-plugin
export default {"root":"DXX_iXIFIv","item":"JA3Yf9GVzR"};